import React, { useEffect, useRef, useState } from 'react';
import { validArray } from 'utils';
import { CheckItem } from 'elements/ListItems';
import styles from './style/select.module.css';
import SelectToggle from './SelectToggle';

const Select = ({
  disabled, handleOnChange, items, label, name, value,
}) => {
  const [open, setOpen] = useState(false);
  const select = useRef();

  const handleClickOutside = (e) => {
    if (select.current.contains(e.target)) {
      return;
    }
    setOpen(false);
  };

  const toggleOpen = () => {
    if (!disabled) {
      setOpen(!open);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  return (
    <div
      className={`
        ${styles.select}
        ${open ? styles.select_open : ''}
        ${value ? styles.select_hasValue : ''}
        ${disabled ? styles.select_disabled : ''}
      `}
      onClick={toggleOpen}
      onKeyDown={toggleOpen}
      ref={select}
      role="button"
      tabIndex={0}
    >
      <SelectToggle
        active={open}
        disabled={disabled}
        label={label}
        value={value}
      />
      <div className={styles.select__options}>
        {validArray(items) && items.map(item => (
          <CheckItem
            borderInset={1}
            checked={value === item}
            handler={e => handleOnChange(e.target.value)}
            key={item}
            label={item}
            name={name}
            value={item}
          />
        ))}
      </div>
    </div>
  );
};

Select.defaultProps = {
  disabled: false,
  value: false,
};

export default Select;
